import * as React from "react";
import {Divider, Icon, Typography } from "../ecosystem";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import moment from "moment-timezone";
import VerifyProviderProfile from "./VerifyProviderProfile";
import VerifyDateTime from "./VerifyDateTime";

const DATE_FORMAT = Tools.getDateFormats();
const DATE_FORMAT_YYYY_MM_DD = "YYYY-MM-DD";

export default class VerifyAndSchedule extends React.Component {
  constructor(props) {
    super(props);
  }

  onEditClick = (e) => {
    if (e) {
      e.preventDefault();
    }
    const {
      stepManager,
      goBack,
      isNonMyChartUser,
      apptInfoStepValue,
    } = this.props;
    goBack(apptInfoStepValue);
    //  this.props.goBack(this.props.stepManager.state.currentStep - 1);
    // goBack(isNonMyChartUser ? stepManager.state.currentStep -2: stepManager.state.currentStep - 1);
  };

  onGoNext(success) {
    if (success) {
      const visit = this.props.visit;
      const date = moment(visit.date).format(DATE_FORMAT_YYYY_MM_DD);
        visit.date = date;
        visit.reasonForVisit = visit.reasonForVisit !== "" ? visit.reasonForVisit : visit.reasonForVisitValue;
      this.props.saveStepInfo({ visit: visit });
      if (this.props.onSubmit) {
        this.props.onSubmit();
      }
    } else {
      this.setState({ showAsInvalid: true });
    }
  }

  getDayOfWeek = (x) => {
    var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    if (Object.prototype.toString.call(dt) === "[object Date]") {
      var strDay = weekday[dt.getDay()];
      return strDay;
    }
    return "Invalid Date";
  };
  date2str = (x) => {
    var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
    const dayName = dt.getDate();
    let monthName = dt.getMonth() + 1;
    if (monthName < 10) monthName = "0" + monthName;
    return `${Tools.getMonthName(monthName.toString())} ${dayName}`;
  };

  formatTime = (s) => {
    let parts = s.split(":");
    let ret = s;
    if (parts.length >= 2) {
      let h = parseInt(parts[0]);
      let m = parseInt(parts[1]);
      let s = parseInt(parts[2]);

      let ispm = h >= 12;
      h = h > 12 ? h - 12 : h;

      ret = `${h.toString()}:${m.toString().padStart(2, "0")} ${
        ispm ? "PM" : "AM"
      }`;
    }
    return ret;
  };

  render() {
    const {
      provider,
      goBack,
      departments,
      providerDetails,
      visit,
      style,
      screenBreakPoint,
      isFromVideoVisitOptions
    } = this.props;
    const selectedDepartmentId = visit.department.id;
    const address =
      selectedDepartmentId && departments
        ? departments.find(
            (item) => item.value.indexOf(selectedDepartmentId) >= 0
          )
        : undefined;
    const prov = {
      photo: provider ? provider.photoUrl : "",
      averageRatingStr: provider ? provider.averageRating : 0,
      reviewCountStr: provider ? provider.ratingCount : 0,
      displayName: provider ? provider.displayName : "", // Jason: you can just populate this from props; also look at care/FindCareResults for how to use StarRatings, etc.
      specialty: provider ? provider.specialty : "",
      Address: {
        locationStreet1: address ? address.address1 : "",
        locationStreet2: address ? address.address2 : "",
        locationCity: address ? address.city : "",
        locationState: address ? address.state : "",
        locationZip: address ? address.zip : "",
      },
    };
    const appt = {
      TimeString: visit.time && this.formatTime(visit.time),
      DayString: visit.date && this.getDayOfWeek(visit.date),
      DateString: this.date2str(visit.date),
    };
    const provPhoto = prov.photo ? prov.photo : "/images/profile-pic.png";
    const defaultPhone =
      providerDetails && providerDetails.consumerCallCenterNumber
        ? providerDetails.consumerCallCenterNumber
        : visit.department
        ? visit.department.phone
        : "";
    const patientStatus =
      visit && visit.acceptType === "Existing"
        ? "Established Patient"
              : "New Patient";
    const visitReasonDesc = visit.reasonForVisit && visit.reasonForVisit === visit.reasonForVisitValue && visit.reasonForVisitValue ? "" : visit.reasonForVisit;

    const isMobile = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE) ? true : false;
    const isTablet = (screenBreakPoint === msgs.LG_TABLET || screenBreakPoint === msgs.MD_TABLET) ? true : false;
    const isXLTablet = screenBreakPoint === msgs.XL_DESKTOP ? true : false;
    const isDesktop = (screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;

    return (
      <div
        className="schedule-visit-reason-container verifyandschedule-provider-workflow"
        style={style}
      >
        <div className="row">
          <div className="col-12">
            <h1 className="step-heading">
                <>Almost done! How does everything look?</>
            </h1>
          </div>
        </div>
        <div className="row verify-appt-details-container">
            {!(isDesktop) &&
                <div className="col-12">
                    <Divider
                        mLeft="none"
                        mRight="none"
                        mTop="none"
                        mBottom="medium"
                    />
                </div>
            }
            <div className="col-12 col-lg-5 order-lg-2 col-xl-4 verify-visit-details">
                <VerifyDateTime
                        dayString={appt.DayString}
                        dateString={appt.DateString}
                        timeString={appt.TimeString}
                        isMobile={isMobile}
                        isTablet={isTablet}
                        isDesktop={isDesktop}
                        onEditClick={(e) => this.onEditClick(e)}
                />
            </div>
            {!(isDesktop) &&
                <div className="col-12">
                    <Divider
                        mLeft="none"
                        mRight="none"
                        mTop="medium"
                        mBottom="medium"
                    />
                </div>
            }
            <div className="col-12 col-lg-7 order-lg-1 col-xl-4 offset-xl-2 verify-dr-details">
                <VerifyProviderProfile
                    photo={provPhoto}
                    name={prov.displayName}
                    specialty={prov.specialty}
                    reviewCount={prov.reviewCountStr}
                    averageRating={prov.averageRatingStr}
                    isVideoVisit={isFromVideoVisitOptions || (visit && visit.isVideoVisit)}
                    address={prov.Address}
                    phone={defaultPhone}
                    patientStatus={patientStatus}
                    isMobile={isMobile}
                    isTablet={isTablet}
                    isXLTablet={isXLTablet}
                    isDesktop={isDesktop}
                />
            </div>
            {!(isDesktop) &&
                <div className="col-12">
                    <Divider
                        mLeft="none"
                        mRight="none"
                        mTop="medium"
                        mBottom="medium"
                    />
                </div>
            }
        </div>
        <div className="row verify-reason-content">
            <div className="col-12 col-xl-8 offset-xl-2">
                <div className="row">
                    <div className="col-12 reason-title">Main Concern</div>
                    <div className="col-12 reason-subtitle">
                        {visit.reasonForVisitValue}
                    </div>
                    {isDesktop && 
                        <div className="col-12">
                            <p className="reason-desc">{visitReasonDesc}</p>
                        </div>
                    }
                </div>
            </div>
        </div>
        {!(isDesktop) &&
            <Divider
                mLeft="none"
                mRight="none"
                mTop="medium"
                mBottom="medium"
            />
        }
        <div className="row verify-info-message">
            <div className="col-12 col-xl-8 offset-xl-2">
                <div className="row">
                    <div className="col-12 verify-info-message__content">
                        <span className="icon-info-filled"></span>
                        <div className="verify-info-text">
                                Prior to your appointment, please contact your insurance
                                carrier to understand facility and provider network status
                                and benefit coverage for your specific insurance plan.
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    );
  }
}
